export default {
  updateRegisterProgressOnEnterActivity(state, value) {
    state.registerProgressOnEnterActivity = value;
  },
};
